import { render, staticRenderFns } from "./lamsRegLegalAdviser.vue?vue&type=template&id=1eef8631&scoped=true&"
import script from "./lamsRegLegalAdviser.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalAdviser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eef8631",
  null
  
)

export default component.exports